import React, { useEffect, useState, useContext } from 'react';
import { connect } from 'react-redux';

import WithRouter from '../utilities/WithRouter';
import {
  setCurrentCampus,
  setCurrentBuilding,
  setCurrentZone,
  setCurrentZoneData,
  setCurrentGX,
  updateCurrentCampusData,
} from '../actions';

import { AppContext } from '../context/AppContext';
import { useCampusMeta } from '../context/CampusContextProvider';
import { useApi } from '../features/api/useApi';

import AuthenticatedComponent from '../utilities/AuthenticatedComponent';

import ComfortIcon from '../components/icons/ComfortIcon';
import icon_building from '../assets/icon_building.svg';
import ZoneCard from '../components/ZoneCard/ZoneCard';
import { MarketingMessageThermalZones } from '../components/MarketingMessage/MarketingMessageThermalZones';
import { Header } from '../components/Header/Header';
import { Breadcrumb } from '../components/Breadcrumb/Breadcrumb';
import { ComfortOverview } from '../features/Comfort/ComfortOverview';
import { SectionCollapseable } from '../components/SectionCollapseable/SectionCollapseable';

import './Comfort.scss';

const Comfort = ({
  router,
  currentCampusId,
  currentCampusData,
  updateCampusCallback,
  currentBuildingId,
  currentZoneId,
  currentZoneData,
  zoneSummaryCallback,
  onBuildingChange,
  onGXChange,
  onZoneChange,
  showMobile,
  openScheduleModal,
  allScheduleCallback,
  currentScheduleData,
  activePage,
  processing,
  setProcessing,
  errorMessage,
  setErrorMessage,
}) => {
  const { appConfig } = useContext(AppContext);
  const campusMeta = useCampusMeta();
  const { fetchDataJson } = useApi();

  const [zoneHealth, setZoneHealth] = useState(null);
  const [sortedCampusBuildings, setSortedCampusBuildings] = useState([]);
  const hasNoZones = appConfig ? appConfig?.sections?.comfort?.hasZones === false : true;

  const campusName = campusMeta ? campusMeta.campusName : '';

  const authenticatedComponent = new AuthenticatedComponent();

  // get campus data
  // TODO: endpoint not working?
  // const {
  //   data: campusData,
  //   isLoading,
  //   error,
  //   refetch: refetchCampusData,
  // } = useQuery({
  //   queryKey: ['campusData', currentCampusId],
  //   queryFn: () => fetchDataJson(`/ahiapi/${currentCampusId}/campus`),
  //   refetchInterval: 5 * 1000, // 5 seconds
  // });

  useEffect(() => {
    if (currentCampusData && currentCampusData.buildings) {
      getBuildingsArray();
    }
  }, []);

  // When device data updates, reload
  useEffect(() => {
    // console.log('currentCampusData', currentCampusData);
    if (currentZoneId === null) {
      zoneSummaryCallback(null);
    }

    if (hasNoZones) {
      return;
    }
    // Device data update every 5 seconds
    if (currentCampusData) {
      if (currentCampusData.buildings) {
        getBuildingsArray();
      }
      if (currentZoneId === null) {
        let interval = setInterval(() => {
          authenticatedComponent.updateCampusData(currentCampusId, updateCampusCallback);
        }, 5000);
        return () => clearInterval(interval);
      }
    }
  }, [currentCampusData, currentZoneId, hasNoZones]);

  useEffect(() => {
    authenticatedComponent.updateCampusData(currentCampusId, updateCampusCallback);
  }, [currentZoneId === null]);

  const getBuildingsArray = () => {
    let tempBuildings = [];

    tempBuildings = currentCampusData.buildings.sort((a, b) => {
      if (a.buildingDescription.buildingEntityKey - b.buildingDescription.buildingEntityKey) {
        return 1;
      }
      if (a.buildingDescription.buildingEntityKey < b.buildingDescription.buildingEntityKey) {
        return -1;
      }
      return 0;
    });

    for (let i = 0; i < tempBuildings.length; i++) {
      tempBuildings[i].thermalZones.sort((a, b) => {
        if (a.longThermalZoneDisplayName - b.longThermalZoneDisplayName) {
          return 1;
        }
        if (a.longThermalZoneDisplayName < b.longThermalZoneDisplayName) {
          return -1;
        }
        return 0;
      });
    }

    setSortedCampusBuildings(tempBuildings);
  };

  const navigateWithValidation = (newPath) => {
    if (router.location.pathname !== newPath) {
      router.navigate(newPath);
    }
  };

  const selectZone = (selectedZoneId, buildingId) => {
    if (selectedZoneId) {
      setCurrentZone(selectedZoneId);
      setCurrentBuilding(buildingId);
      setCurrentGX(null);
      setCurrentZoneData(null);

      navigateWithValidation(
        '/comfort/' +
          currentCampusData.campusDescription.campusEntityKey +
          '/' +
          buildingId +
          '/' +
          selectedZoneId
      );

      authenticatedComponent.getZoneSummary(selectedZoneId, zoneSummaryCallback);
    }
  };

  const renderHeaderLockup = () => {
    return (
      <>
        <ComfortIcon
          backgroundFill="none"
          fillColor={'#02222B'}
          strokeColor={'#02222B'}
          strokeWidth={2.5}
          width="18px"
        />
        <h1>Comfort</h1>
      </>
    );
  };

  return (
    <section className={showMobile ? 'comfort-section mobile' : 'comfort-section desktop'}>
      <Header siteName={campusName} showWeather={currentCampusData}>
        <Breadcrumb iconHeader={renderHeaderLockup()} />
      </Header>

      <div className="comfort-content">
        {hasNoZones ? (
          <MarketingMessageThermalZones />
        ) : (
          <>
            <ComfortOverview campusData={currentCampusData} />
            {sortedCampusBuildings.map((building, index) => {
              // console.log('building', building);
              return (
                <React.Fragment key={`building-${index}`}>
                  <div className="building-container">
                    <SectionCollapseable
                      customHeading={
                        <div className="building-header">
                          <img src={icon_building} alt="building icon" width="20" height="20" />
                          <h3 className="building-name">
                            {building.buildingDescription.longBuildingDisplayName}
                          </h3>
                        </div>
                      }
                    >
                      {building.thermalZones.length !== 0 ? (
                        <div className="thermal-zones--list ">
                          <div className="labels">
                            <div className="head location header-text--sm">Location</div>
                            <div className="head temp-range header-text--sm">
                              Temp{' '}
                              <span style={{ fontSize: '11px', color: '#62797e' }}>(Settings)</span>
                            </div>
                            <div className="head activity header-text--sm">Activity</div>
                            <div className="head keypad header-text--sm">Keypad</div>
                            <div className="head control header-text--sm">Active Control</div>
                            <div className="head schedule header-text--sm">Schedule</div>
                          </div>
                          <div className="zones">
                            {building.thermalZones.map((zoneData, index) => (
                              <React.Fragment
                                key={`${zoneData.shortThermalZoneDisplayName}${index}`}
                              >
                                <ZoneCard
                                  zoneRealtimeData={zoneData}
                                  selectZone={() =>
                                    selectZone(
                                      zoneData.thermalZoneEntityKey,
                                      building.buildingDescription.buildingEntityKey
                                    )
                                  }
                                  setZoneHealth={setZoneHealth}
                                />
                              </React.Fragment>
                            ))}
                          </div>
                        </div>
                      ) : (
                        <div className="building-empty-state">
                          <ComfortIcon
                            backgroundFill="none"
                            fillColor={'#02222B'}
                            strokeColor={'#02222B'}
                            strokeWidth={2.5}
                            width="18px"
                          />
                          <p>There are no zones to display.</p>
                        </div>
                      )}
                    </SectionCollapseable>
                  </div>
                </React.Fragment>
              );
            })}
          </>
        )}
      </div>
    </section>
  );
};

const mapStateToProps = (state) => {
  return {
    campuses: state.campuses,
    currentCampusId: state.currentCampusId,
    currentBuildingId: state.currentBuildingId,
    currentZoneId: state.currentZoneId,
    currentGXId: state.currentGXId,
    currentCampusData: state.currentCampusData,
    setCurrentZoneData: state.currentZoneData,
    currentUserData: state.currentUserData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCurrentCampus: (campusId) => {
      dispatch(setCurrentCampus(campusId));
    },
    setCurrentBuilding: (buildingId) => {
      dispatch(setCurrentBuilding(buildingId));
    },
    setCurrentZone: (zoneId) => {
      dispatch(setCurrentZone(zoneId));
    },
    setCurrentZoneData: (zoneId) => {
      dispatch(setCurrentZoneData(zoneId));
    },
    setCurrentGX: (gxId) => {
      dispatch(setCurrentGX(gxId));
    },
    updateCurrentCampusData: (campusData) => {
      dispatch(updateCurrentCampusData(campusData));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(Comfort));
